import React, {useEffect, useState} from 'react'
import io from 'socket.io-client'
import './Chat.css'
import Message from './Message.js'
import ScrollToBottom from 'react-scroll-to-bottom'
import { useParams } from 'react-router-dom'

let socket = null;

export default function Chat() {
    const ENDPOINT = 'https://express-chat-backend-server.herokuapp.com/'
    
    const [message, setMessage] = useState('')
    const [messages, setMessages] = useState([])
    const [displayMessage, setDisplayMessage] = useState('Please wait, while server is connecting!')

    const { name, room } = useParams()

    const send_message = () => {
        if(message) {
            socket.emit('send_message', {name: name, message: message})
            setMessage('')
        } else {
            alert('emtpy message')
        }
    }

    const redirectToHome = () => {
        window.location.href = '/'
    }

    useEffect(() => {
        try{
            socket = io(ENDPOINT,{transports: ['websocket']})

            if(!socket) setDisplayMessage('Server crashed, please try again later!')

            socket.emit('join', {name, room}, (error) => {
                if(error) {
                    alert(error)
                    window.location.href = '/'
                }
            })
        } catch(error) {
            console.log(error)
        }

        return () => {
            socket.off()
        }
    }, [ENDPOINT, name, room])

    useEffect(() => {
        socket.on('message', (message) => {
            if(messages === null) setMessages([])
            setMessages([...messages, message])
        })
    }, [messages])

    return (
        
        <div className="container">
            
            <div className="chatbox">

                <div className="chatbox__heading">{room}</div>

                <div className="chatbox__messages">
                    <ScrollToBottom>
                    {
                        messages.length !== 0 ? 
                        messages.map((message) => (
                            message.user === "admin" ? <div align="center"><Message user={message.user} message={message.message} /></div> : 
                            message.user === 'You' ? <div align="right"><Message user={message.user} message={message.message} /></div> : <div align="left"><Message user={message.user} message={message.message} /></div>
                        )) 
                        : 
                        <div>
                            <h1 style={{color: "#E1D89F"}}>{displayMessage}</h1>
                            <button onClick={redirectToHome}>Return Home</button>
                        </div>
                    }
                    </ScrollToBottom>
                </div>

                <div className="chatbox__footer">
                    <input type="text" value={message} onChange={(e) => setMessage(e.target.value)} onKeyDown={(e) => {if(e.key === 'Enter') send_message()} }  />
                    <button className="chatbox__button" onClick={send_message}>Send</button>
                </div>

            </div>
            
        </div>

    )
}
